import { makeStyles, createStyles } from '@material-ui/core'

export const styles = () => createStyles({
  tableCell: {
    width: 100,
    '&:nth-child(2)': {
      minWidth: 83,
      whiteSpace: 'normal'
    },
    '&:first-child': {
      width: 350
    },
    whiteSpace: 'nowrap'
  },

  containerName: {
    marginLeft: '9px !important'
  },
  containerCheckbox: {
    marginLeft: 5
  },
});

export default makeStyles(styles)